import { createContext } from "react";
import { IDeviceUpdaterAPI } from "../../../interfaces/daos";

export const DeviceContext = createContext<any | null>(null);

export const DeviceUpdaterContext = createContext<IDeviceUpdaterAPI | null>(null);
